import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  BarElement,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

import dayjs from "dayjs";
ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarElement
);
import { Chart } from "react-chartjs-2";

function CombinedChart({ fortuneData }) {
  console.log(fortuneData, 123);
  const { labels, totalCounts, typeCountsByDate, allTypes } =
    prepareChartData(fortuneData);

  const chartData = {
    labels,
    datasets: [
      // ✅ 선 그래프: 전체 요청 수
      {
        type: "line",
        label: "총 요청 수",
        data: totalCounts,
        borderColor: "rgba(75,192,192,1)",
        backgroundColor: "transparent",
        tension: 0.1,
        yAxisID: "y",
      },
      // ✅ 막대 그래프: type별 요청 수
      ...allTypes.map((type, idx) => ({
        type: "bar",
        label: type,
        data: labels.map((date) => typeCountsByDate[date]?.[type] || 0),
        backgroundColor: getColor(idx),
        stack: "typeStack",
        yAxisID: "y",
      })),
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "날짜별 운세 요청 수 + 타입별 분포",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: true, text: "건수" },
      },
      x: {
        title: { display: true, text: "날짜" },
      },
    },
  };

  return (
    <div style={{ background: "#fff", padding: 20, borderRadius: 12 }}>
      <Chart type="bar" data={chartData} options={options} />
    </div>
  );
}

function FortuneChart({ fortuneData }) {
  const { labels, data } = fortuneData;

  const chartData = {
    labels,
    datasets: [
      {
        label: "운세 요청 수",
        data,
        borderColor: "rgba(75,192,192,1)",
        tension: 0.1,
        fill: false,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "날짜별 운세 요청 수",
      },
      legend: {
        display: true,
      },
    },
  };

  return <Line data={chartData} options={options} />;
}

function FortuneChartsByType({ fortuneData }) {
  const { labels, values } = fortuneData;

  const data = {
    labels, // ['today', 'monthly', 'travel', ...]
    datasets: [
      {
        label: "운세 요청 수",
        data: values, // [12, 5, 7, ...]
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "타입별 운세 요청 총합",
      },
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: true, text: "요청 수" },
      },
      x: {
        title: { display: true, text: "운세 타입" },
      },
    },
  };

  return (
    <div
      style={{
        padding: "24px",
        backgroundColor: "#fff",
        borderRadius: "12px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      }}
    >
      <Bar data={data} options={options} />
    </div>
  );
}

function LanguageChart({ fortuneData }) {
  console.log(fortuneData);
  const { labels, values } = fortuneData;

  const data = {
    labels,
    datasets: [
      {
        label: "언어별 운세 요청 수",
        data: values,
        backgroundColor: "rgba(153, 102, 255, 0.6)",
        borderColor: "rgba(153, 102, 255, 1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "언어별 운세 요청 총합",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: true, text: "건수" },
      },
      x: {
        title: { display: true, text: "사용자 언어" },
      },
    },
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "16px",
        borderRadius: "12px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      }}
    >
      <Bar data={data} options={options} />
    </div>
  );
}

function GenderChart({ fortuneData }) {
  const { labels, values } = fortuneData;

  const data = {
    labels,
    datasets: [
      {
        label: "성별 요청 수",
        data: values,
        backgroundColor: ["#4B9EFF", "#FF6FA0"], // 남자: 파랑, 여자: 핑크
        borderRadius: 8,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "성별별 운세 요청 수",
      },
      legend: { display: false },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: true, text: "요청 수" },
      },
      x: {
        title: { display: true, text: "성별" },
      },
    },
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "16px",
        borderRadius: "12px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      }}
    >
      <Bar data={data} options={options} />
    </div>
  );
}

function prepareChartData(data) {
  const labelsSet = new Set();
  const typeCountsByDate = {};
  const totalCountsByDate = {};
  const allTypesSet = new Set();

  data.forEach((item) => {
    const date = dayjs(item.fortuneDate).format("YY-MM-DD");
    const type = item.type || "unknown";

    labelsSet.add(date);
    allTypesSet.add(type);

    if (!typeCountsByDate[date]) typeCountsByDate[date] = {};
    if (!typeCountsByDate[date][type]) typeCountsByDate[date][type] = 0;

    typeCountsByDate[date][type] += 1;

    totalCountsByDate[date] = (totalCountsByDate[date] || 0) + 1;
  });

  const labels = Array.from(labelsSet).sort();
  const totalCounts = labels.map((date) => totalCountsByDate[date] || 0);
  const allTypes = Array.from(allTypesSet);

  return { labels, totalCounts, typeCountsByDate, allTypes };
}

// ✅ 색상 배열
function getColor(index) {
  const colors = [
    "rgba(255,99,132,0.6)",
    "rgba(54,162,235,0.6)",
    "rgba(255,206,86,0.6)",
    "rgba(75,192,192,0.6)",
    "rgba(153,102,255,0.6)",
    "rgba(255,159,64,0.6)",
  ];
  return colors[index % colors.length];
}

export {
  FortuneChart,
  FortuneChartsByType,
  CombinedChart,
  LanguageChart,
  GenderChart,
};
